import React from "react";
import PropTypes from "prop-types";
import arrow from "../../assets/imgs/dropDown-arrow.png";

const EventsListHeader = ({ handleSort, isDesc, sortBy }) => {
  const categories = ["Time", "Events", "Player", "Position"];

  return (
    <ul className="event-list-header">
      {categories.map((category, i) => (
        <li key={i} onClick={()=> handleSort(category)} className="event-list-header--item">
          {category}
          {sortBy === category.toLowerCase() &&
            <img
              src={arrow}
              style={isDesc ? { transform: "scaleY(-1)" } : {}}
              alt=""
            />
          }
        </li>
      ))}
    </ul>
  );
};

EventsListHeader.propTypes = {
  handleSort: PropTypes.func,
  isDesc: PropTypes.bool
};
EventsListHeader.defaultProps = {
  handleSort: () => {},
  isDesc: true
};

export default EventsListHeader;
